/* eslint-disable */

/** Represents a dialog that the mobile client can present. */
export interface TaxWebBridgeDialog {
  /** The title to display in the dialog. */
  title?: string;
  /** The message to display in the dialog. */
  message?: string;
  /**
   * A button to show in the primary position on the dialog,
   * generally on the right if the locale is a LTR language.
   * Required.
   */
  primary_button?: TaxWebBridgeDialogButton;
  /**
   * A button to show in the secondary position on the dialog,
   * generally on the left if the locale is a LTR language.
   * Optional.
   */
  secondary_button?: TaxWebBridgeDialogButton;
}

/**
 * Represents a button that can be shown
 * at the bottom of the dialog.
 */
export interface TaxWebBridgeDialogButton {
  /**
   * The ID of the button. Used in the `DialogButtonTapEventRequest`
   * to tell the web client which button was tapped.
   */
  id?: string;
  /** The title of the button to display. */
  title?: string;
  /** The style of the button title to display. */
  style?: TaxWebBridgeDialogButtonStyle;
  /** The action to take when the button is tapped. */
  action?: TaxWebBridgeDialogButtonAction;
}

/**
 * An action that can be specified to
 * be taken when the button is tapped.
 */
export enum TaxWebBridgeDialogButtonAction {
  /** CLOSE_DIALOG - Specifies that the dialog should be closed. */
  CLOSE_DIALOG = "CLOSE_DIALOG",
  /**
   * SUBMIT_REQUEST - Specifies that a DialogButtonTapEventRequest should
   * be sent to the web client with the button ID.
   */
  SUBMIT_REQUEST = "SUBMIT_REQUEST",
}

/** The style of the button, which determines the title color. */
export enum TaxWebBridgeDialogButtonStyle {
  /** DEFAULT - The title will use the default title color, the Cash tint color. */
  DEFAULT = "DEFAULT",
  /** DESTRUCTIVE - The title will use a destructive title color, red. */
  DESTRUCTIVE = "DESTRUCTIVE",
}
